import { useState } from "react";
import { mapsEmbedUrl, placeQuery, REVIEW_URL_MAX, REVIEW_URL_PATTERN } from "../../menu.js";
import { cleanLine } from "../../businessValidation.js";
import { notifyError } from "./useBusiness";
import Icon from "./Icon";

// Reseñas de Google en el menú (todos los planes): el botón "Dejanos tu reseña" con el link
// del Perfil de Empresa de Google y la ficha de Maps con las estrellas del local.
const ReviewsCard = ({ business, onSave, onEditData }) => {

    const [url, setUrl] = useState(business.resenasUrl || "");
    const [ficha, setFicha] = useState(business.fichaGoogle === true);
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);

    const embed = mapsEmbedUrl(business);
    const hasAddress = !!(business.calle && business.ciudad);
    const changed = url.trim() !== (business.resenasUrl || "") || ficha !== (business.fichaGoogle === true);

    const save = async (e) => {
        e.preventDefault();
        const clean = cleanLine(url);
        if (clean && (clean.length > REVIEW_URL_MAX || !REVIEW_URL_PATTERN.test(clean))) {
            setError("Pegá el link que te da Google para pedir reseñas. Empieza con https://g.page/, https://maps.app.goo.gl/ o https://search.google.com/.");
            notifyError("Revisá el link de reseñas.");
            return;
        }
        setError("");
        setUrl(clean);
        setSaving(true);
        await onSave({ resenasUrl: clean, fichaGoogle: ficha });
        setSaving(false);
    }

  return (
    <form className="lp-panel-card lp-panel-stack" onSubmit={save} noValidate>
        <div className="lp-panel-card-head">
            <h2>Reseñas de Google</h2>
        </div>
        <p className="lp-panel-muted">Mostrá en tu menú las estrellas que tenés en Google Maps y pediles a tus clientes que te dejen una reseña.</p>

        {embed &&
            <>
                <button type="button" className="lp-panel-switch lp-panel-switch-plain" role="switch" aria-checked={ficha} disabled={!hasAddress} onClick={() => setFicha(!ficha)}>
                    <span className="lp-panel-switch-track"><span className="lp-panel-switch-knob"></span></span>
                    <span className="lp-panel-switch-text">Mostrar mi ficha de Google Maps</span>
                </button>
                {!hasAddress &&
                    <p className="lp-panel-notice">Para mostrar tu ficha cargá la dirección del negocio. <button type="button" className="lp-text-link" onClick={onEditData}>Completar datos</button></p>
                }
                {ficha && hasAddress &&
                    <div className="lp-panel-stack">
                        <iframe className="lp-panel-map" title="Vista previa de tu ficha de Google Maps" src={embed} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen></iframe>
                        <p className="lp-field-hint">Buscamos "{placeQuery(business)}". Si no aparece tu local con sus estrellas, revisá que el nombre y la dirección sean los mismos que en Google Maps, o apagá la ficha.</p>
                    </div>
                }
            </>
        }

        <div className="lp-field">
            <label htmlFor="rv-url">Link para dejar reseña (opcional)</label>
            <input id="rv-url" type="url" inputMode="url" autoCapitalize="none" spellCheck="false" maxLength={REVIEW_URL_MAX} placeholder="https://g.page/r/..." value={url} onChange={(e) => { setUrl(e.target.value); setError(""); }} aria-invalid={error ? true : undefined} aria-describedby={error ? "rv-error" : "rv-hint"}/>
            {error && <span className="lp-field-error" id="rv-error" role="alert">{error}</span>}
            <span className="lp-field-hint" id="rv-hint">En Google buscá tu negocio, entrá a <strong>Pedir reseñas</strong> (o "Obtener más reseñas") y copiá el link. Con el link, tu menú muestra el botón "Dejanos tu reseña".</span>
        </div>

        <div className="lp-panel-actions">
            <button className="lp-btn lp-btn-primary lp-panel-btn-sm" type="submit" disabled={saving || !changed}>
                <Icon name="star" size={18}></Icon> {saving ? "Guardando..." : "Guardar"}
            </button>
        </div>
    </form>
  )
}

export default ReviewsCard
